export const DATE_FORMAT = {
  YEAR_MONTH_DATE: 'YYYY/MM/DD',
  DOT_MONTH_DATE_YEAR: 'MM.DD.YYYY',
  DOT_MONTH_DATE_YEAR_WITH_TIME: 'MM.DD.YYYY HH:mm',
  MONTH_DATE_YEAR: 'MM/DD/YYYY',
  FORMAT_DATE_CHART: 'MMM DD',
  FORMAT_DATE_YEAR_CHART: 'MMM DD, YYYY',
  FORMAT_DATE_CHART_TOOLTIP: 'MMM D, YYYY HH:mm',
  MONTH_DAY: 'M/D',
  TIME: 'HH:mm',
  YEAR_MONTH_DATE_DASH: 'YYYY-MM-DD',
  FULL_TIME: 'HH:mm:ss',
  DATE_TIME_AMPM_FORMAT: 'MMM. D, YYYY h:mm A',
  DATE_TIME_FORMAT: 'MMM. D, YYYY hh:mm:ss',
  LONG_MONTH_YEAR: 'MMMM YYYY',
};

export const SECONDS_IN_YEAR = 31536000;
